import * as types from "./types";

export const setUploadProgress = (path, value) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_UPLOAD_PROGRESS,
      payload: { path, value },
    });
  };
};
